import { CSSProperties } from 'react';
import { COLORS, FONTS, META, GLASS } from '../../globalStyles';

export const styles: Record<string, CSSProperties> = {
  grid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1.5fr',
    gap: '1.25rem',
    alignItems: 'start',
    marginTop: '3.5rem',
  },
  founderCard: {
    width: '85%',
    background: COLORS.surface,
    border: `1px solid ${COLORS.border}`,
    borderRadius: 0,
    overflow: 'hidden',
  },
  // Glass tile around the body copy — matches the services/products glass.
  textTile: {
    ...GLASS,
    border: `1px solid ${COLORS.border}`,
    padding: '1.75rem',
  },
  avatar: {
    width: '100%',
    aspectRatio: '4/5',
    background: `linear-gradient(135deg, ${COLORS.bg2} 0%, ${COLORS.surface} 100%)`,
    overflow: 'hidden',
  },
  avatarImg: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    objectPosition: 'center top',
    display: 'block',
  },
  founderMeta: {
    padding: '1.35rem 1.5rem',
    borderTop: `1px solid ${COLORS.border}`,
  },
  founderName: {
    fontFamily: FONTS.body,
    fontSize: '1.05rem',
    fontWeight: 600,
    color: COLORS.text,
    marginBottom: '0.4rem',
  },
  founderTitle: {
    ...META,
    fontSize: '0.66rem',
    color: COLORS.faint,
  },
  bodyText: {
    color: COLORS.muted,
    lineHeight: 1.8,
    marginBottom: '1.25rem',
  },
  bodyStrong: {
    color: COLORS.text,
    fontWeight: 500,
  },
  footnote: {
    ...META,
    fontSize: '0.66rem',
    color: COLORS.faint,
    lineHeight: 1.9,
    marginTop: '0.5rem',
    paddingTop: '1.5rem',
    borderTop: `1px solid ${COLORS.border}`,
  },
};
